import React from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import Breadcrumbs from "./Breadcrumbs";

export default function InfoLayout({ title, subtitle, crumb, children }) {
  return (
    <div className="App relative">
      <Navbar />
      <section className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
        <Breadcrumbs items={[{ label: crumb }]} />
        <h1 className="mt-4 font-heading text-4xl sm:text-5xl font-extrabold tracking-tight">{title}</h1>
        {subtitle && <p className="mt-3 text-lg text-muted-foreground">{subtitle}</p>}
        <div className="mt-8 markdown">{children}</div>
      </section>
      <Footer />
    </div>
  );
}
